import { useAppSelector } from '../../../redux/hooks.ts'
import { selectThemeStyle } from '../../../features/setting/setting.slice.ts'
import { convertPxToNumber } from '../../../utils/helpers.ts'
import { useDispatch } from 'react-redux'
import {
  selectManagementInput,
  setCategory,
  setExpiredTicker,
} from '../../../redux/slices/management-input.slice.ts'
import { IdeyaButton } from '../../../common/antd/ideya-button/ideya-button.tsx'
import { TickerStatus } from '../../../enums/management-input.enum.ts'
import { VerticalSeparator } from '../../../common/components/vertical-separator.tsx'
import { useIsMobile } from '../../../common/hooks/use-is-mobile.ts'
import Col from 'antd/es/grid/col'
import Row from 'antd/es/grid/row'
import { IdeyaSegmented } from '../../../common/antd/ideya-segmented.tsx'
import Select from 'antd/es/select/index'
import { useTranslation } from 'react-i18next'
import { useIsSuperViewer } from '../../../common/hooks/use-is-superviewer.ts'

interface TickerManagementUserControlsProps {
  onCreateTicker: () => void
}

export const TickerManagementUserControls: React.FC<
  TickerManagementUserControlsProps
> = ({ onCreateTicker }) => {
  const { t } = useTranslation()
  const themeStyle = useAppSelector(selectThemeStyle)
  const managementInput = useAppSelector(selectManagementInput)
  const dispatch = useDispatch()
  const isMobile = useIsMobile(768)
  const isSuperViewer = useIsSuperViewer()

  return (
    <Row
      align={'bottom'}
      justify={isMobile ? 'start' : 'space-between'}
      style={{
        marginBottom: themeStyle.marginSM,
        flexDirection: isMobile ? 'column' : 'row',
        alignItems: isMobile ? 'start' : '',
      }}
    >
      <Col flex={isMobile ? 'unset' : 1}>
        {isMobile ? (
          <Row gutter={[12, 12]}>
            <Col xs={24}>
              <Row>
                <IdeyaSegmented
                  onChange={(value) => {
                    const isExpired = value === TickerStatus.Expired
                    dispatch(setExpiredTicker(isExpired))
                  }}
                  options={[
                    {
                      value: TickerStatus.Active,
                      label: t('ticker_management.user_controls.active'),
                    },
                    {
                      value: TickerStatus.Expired,
                      label: t('ticker_management.user_controls.expired'),
                    },
                  ]}
                />
              </Row>
            </Col>
            <Col xs={24}>
              <Row>
                <Select
                  value={managementInput.category}
                  style={{ width: '100%' }}
                  onChange={(value) => dispatch(setCategory(value))}
                  options={[
                    {
                      value: '',
                      label: isMobile
                        ? t('common.user_controls.all_categories')
                        : t('common.user_controls.all'),
                    },
                    { value: 'Japan', label: 'Japan' },
                    { value: 'Greater China', label: 'Greater China' },
                    { value: 'India', label: 'India' },
                    { value: 'Korea', label: 'Korea' },
                    { value: 'Australia', label: 'Australia' },
                  ]}
                />
              </Row>
            </Col>
            {
              // Temporarily hide the date range filter (ideya-878)
              /*<Col xs={24}>
              {!isMobile && (
                <Row style={{ paddingBottom: themeStyle.paddingXS }}>
                  <IdeyaTypography.Text>
                    {t('common.user_controls.time_interval')}
                  </IdeyaTypography.Text>
                </Row>
              )}
              <Row>
                <IdeyaRangePicker
                  value={[
                    dayjs(managementInput.dateRange[0]),
                    dayjs(managementInput.dateRange[1]),
                  ]}
                  onChange={(dates) => {
                    dispatch(
                      setManagementInputDateRange([
                        dates?.[0] ? dates[0].format('YYYY-MM-DD') : null,
                        dates?.[1] ? dates[1].format('YYYY-MM-DD') : null,
                      ])
                    )
                  }}
                  style={{ width: '100%' }}
                />
              </Row>
            </Col>*/
            }
          </Row>
        ) : (
          // Desktop: keep vertical separators
          <Row
            gutter={[
              convertPxToNumber(themeStyle.marginBase),
              convertPxToNumber(themeStyle.marginBase),
            ]}
          >
            <Col>
              <Row>
                <IdeyaSegmented
                  onChange={(value) => {
                    const isExpired = value === TickerStatus.Expired
                    dispatch(setExpiredTicker(isExpired))
                  }}
                  options={[
                    {
                      value: TickerStatus.Active,
                      label: t('ticker_management.user_controls.active'),
                    },
                    {
                      value: TickerStatus.Expired,
                      label: t('ticker_management.user_controls.expired'),
                    },
                  ]}
                />
              </Row>
            </Col>
            <Col>
              <VerticalSeparator />
            </Col>
            <Col md={3}>
              <Row>
                <Select
                  showSearch
                  style={{
                    width: '100%',
                  }}
                  value={managementInput.category}
                  onChange={(value) => dispatch(setCategory(value))}
                  options={[
                    {
                      value: '',
                      label: t('common.user_controls.all_categories'),
                    },
                    { value: 'Japan', label: 'Japan' },
                    { value: 'Greater China', label: 'Greater China' },
                    { value: 'India', label: 'India' },
                    { value: 'Korea', label: 'Korea' },
                    { value: 'Australia', label: 'Australia' },
                  ]}
                />
              </Row>
            </Col>
            {
              // Temporarily hide the date range filter (ideya-878)
              /*<Col>
              <Row style={{ paddingBottom: themeStyle.paddingXS }}>
                <IdeyaTypography.Text>Time Interval</IdeyaTypography.Text>
              </Row>
              <Row>
                <IdeyaRangePicker
                  value={[
                    dayjs(managementInput.dateRange[0]),
                    dayjs(managementInput.dateRange[1]),
                  ]}
                  onChange={(dates) => {
                    dispatch(
                      setManagementInputDateRange([
                        dates?.[0] ? dates[0].toISOString() : null,
                        dates?.[1] ? dates[1].toISOString() : null,
                      ])
                    )
                  }}
                />
              </Row>
            </Col>*/
            }
          </Row>
        )}
      </Col>
      {!managementInput.expiredTicker && !isSuperViewer && (
        <Col
          style={
            isMobile
              ? {
                  marginTop: 16,
                  width: '100%',
                  display: 'flex',
                  justifyContent: isMobile ? 'start' : 'flex-end',
                }
              : {}
          }
        >
          <IdeyaButton
            onClick={onCreateTicker}
            style={isMobile ? { width: 140 } : {}}
          >
            {t('ticker_management.user_controls.create_ticker_rule')}
          </IdeyaButton>
        </Col>
      )}
    </Row>
  )
}
